import { EventTriggers } from '../rulesets';
import { RulesetTemplate } from './template';

export const OffsiteRulesets: { [key: string]: RulesetTemplate } = {
  CartAbandonment: {
    icon: 'modal-window',
    name: 'Cart Abandonment',
    detail: (
      <p>
        A <b>Cart abandonment campaign</b> that allows the user to be targeted for cart remarketing.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.Email',
          templateId: 'cart',
          delay: 0,
        },
      ],
      eventTriggers: [EventTriggers.INACTIVITY],
      name: 'Cart abandonment',
      rules: [{ type: '.CartAbandonment', unsubscribeDefined: false }],
      subFeature: 'REMINDER',
    },
  },
  BrowseAbandonment: {
    icon: 'modal-window',
    name: 'Browse Abandonment',
    detail: (
      <p>
        A <b>Browse abandonment campaign</b> that allows the user to be targeted for browse remarketing.
      </p>
    ),
    ruleset: {
      channels: [
        {
          type: '.Email',
          templateId: 'browse',
          delay: 7,
        },
      ],
      eventTriggers: [EventTriggers.INACTIVITY],
      name: 'Browse abandonment',
      rules: [{ type: '.BrowseAbandonment', minSessionTime: 0 }],
      subFeature: 'REMINDER',
    },
  },
};
